import api from "@/utils/api.js";
export default {
    namespaced: true,
    state: {
        menuList: [],
    },
    mutations: {
        SET_QUIPMENTLIST(state, params) {
            state.menuList = params;
        }
    },
    actions: {
        UPDATE_QUIPMENTLIST({ commit }, params) {
            commit('SET_QUIPMENTLIST', params);
        },
        /* 獲取左側列表有權限 */
        async getMenu({ commit, state }) {
            try {
                let res = await api.Querypermission({
                    uid:0
                });
                if (res.code == 200) {
                    const equipmentList = res.conten || [];
                    let menuListArr = []
                    if (res.conten.length > 0) {
                        menuListArr = equipmentList.map((item) => {
                            // 若后端返回的是 t 字段，转为 children
                            if (item.t) {
                                return { ...item, children: item.t };
                            }
                            return item;
                        });
                    }

                    commit('SET_QUIPMENTLIST', menuListArr);
                    // console.log(menuListArr,'menuListArr')
                    return menuListArr; // 返回数据供组件使用
                }

            } catch (e) {
                console.error("获取左側列表:", e);
            }
        },


    },
    getters: {
        menuList: state => state.menuList,

    },
};